import { PropsWithChildren } from 'react';
import cn from 'classnames';

import s from './styles.module.css';

type ContentWrapperProps = PropsWithChildren<{
  className?: string;
}>;

const ContentWrapper = ({ children, className = '' }: ContentWrapperProps) => (
  <div className={cn(s.root, { [className]: className })}>{children}</div>
);

export default ContentWrapper;
